import React from 'react'

const Main: React.FC<{ color1?: string, color2?: string }> = React.memo(({ 
    color1 = "text-primary", 
    color2 = 'text-primary-shadow' 
}) => {
    return (
        <div className='flex items-center w-fit'>
            <svg 
                className={color1 + ' blur-support -mt-24'} 
                width="150" 
                height="200" 
                viewBox="0 0 154 206" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
                    d="M94.8964 100.293C94.8964 152.047 168.238 205.534 116.484 205.534C64.7305 205.534 0 144.401 0 92.6476C0 40.894 85.8685 0 137.622 0C189.376 0 94.8964 48.5396 94.8964 100.293Z" 
                    fill="currentColor" 
                />
            </svg>

            <svg 
                className={color2 + '  blur-support mt-20'} 
                width="150" 
                height="200" 
                viewBox="0 0 154 210" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
                    d="M153.283 175.111C153.283 226.865 104.215 205.694 52.4617 205.694C0.708055 205.694 36.7988 162.102 36.7988 110.348C36.7988 58.5942 -32.0454 0.160156 19.7083 0.160156C71.4619 0.160156 153.283 123.358 153.283 175.111Z" 
                    fill="currentColor" 
                />
            </svg>
        </div>
    )
});

Main.displayName = 'Main';

export default Main;